export default {
  validation: {
    required: '此项为必填项',
    kana_format: '',
    email_format: '请以 @.lower:validation.variables.email 输入',
    date_format: '请以 @.lower:validation.variables.date 输入',
    number_format: '请以 @.lower:validation.variables.number',
    halfwidth_number_format: '请仅输入半角数字。',
    alphanumeric_format: '请以 @.lower:validation.variables.alphanumeric 输入',
    postal_number_no_hyphen: '请以 @.lower:validation.variables.postal_number 输入',
    postal_number_format: '邮政编码请指定为无连字符',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    login_password_format: '请以输入 6字符以上',
    min_length: '请以输入 {length} 字符以上',
    max_length: '请以输入 {length} 字符以内',
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: '请输入 {digit} 位以内的数字。',
    max_digit_with_item: '请在 {digit} 位数以内输入 {item}',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: '不能仅输入空格或换行符',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/电子邮件地址',
      email: '电子邮件地址',
      password: '密码',
      kana: '',
      date: '日期（例: 31/01/2023）',
      number: '数字',
      alphanumeric: '半角英文和数字',
      postal_number: '邮政编码',
    },
  },
}
